import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import InstallerCard from './components/installerCard';
import MessageBox from 'components/MessageBox';
import ListView from 'components/ListView';
import { requestInstallerList, requestEmployee } from 'actionCreators';
import { getInstallerList, getInstallerLoading, getInstallerHasNextPage } from '../../../../reducers';
import connectUI from 'redux-ui';

class InstallerList extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    ui: PropTypes.object,
    updateUI: PropTypes.func,
    needsMore: PropTypes.bool,
    installers: PropTypes.array,
    loading: PropTypes.bool,
    requestInstallerList: PropTypes.func,
    requestEmployee: PropTypes.func,
    user: PropTypes.object,
  }

  componentDidMount = () => {
    this.props.requestInstallerList();
    this.requestEmployeeById();
  }

  componentWillUnmount = () => {
    if (this.props.ui.successMessage) this.props.updateUI('successMessage', '');
  }

  requestEmployeeById = () => this.props.requestEmployee(this.props.user.employable_id)

  handleInfiniteLoad = () => {
    if (this.props.needsMore) {
      this.props.requestInstallerList();
      this.requestEmployeeById();
    }
  }

  render = () => {
    const { installers, needsMore, loading, user } = this.props;
    return (<div>
      {this.props.ui.successMessage ?
        <MessageBox message={this.props.ui.successMessage} /> : null}
      <ListView
        loading={loading}
        needsMore={needsMore}
        handleInfiniteLoad={this.handleInfiniteLoad}
      >
        {installers.map(installer => (<InstallerCard
          key={`installer-${installer.id}`}
          installer={installer}
          user={user}
        />))}
      </ListView>
    </div>);
  }
}

const mapStateToProps = state => ({
  loading: getInstallerLoading(state),
  installers: getInstallerList(state),
  needsMore: getInstallerHasNextPage(state),
  user: state.user,
});

export default connectUI()(connect(
  mapStateToProps, { requestInstallerList, requestEmployee },
)(InstallerList));



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/installers/installerList.jsx